const clearAllHandler = require('./clear-all-handler');
const handleCheckboxes = require('./handle-checkboxes');
const handleFilterToggles = require('./handle-filter-toggles');
const handleTags = require('./handle-tags');
const handleShowMore = require('./handle-show-more');
const handleBackToTop = require('./handle-back-to-top');
const handleModalInteraction = require('./handle-modal-interaction');
const updateFilterAccessibility = require('./update-filter-accessibility');

module.exports = function () {
    var $searchRendering = $('.search-rendering');

    if (!$searchRendering.length) {
        return;
    }
    
    window.searchRenderingInitialized = window.searchRenderingInitialized || false;

    if (!window.searchRenderingInitialized) {                

        var apiEndpoint = $searchRendering.data('searchEndpoint');

        if (!window.pageInitialized) {
            clearAllHandler(apiEndpoint);
        }

        handleCheckboxes(apiEndpoint);
        handleFilterToggles($searchRendering);
        handleTags($searchRendering);
        handleModalInteraction(apiEndpoint);
        handleShowMore(apiEndpoint, $searchRendering);
        handleBackToTop($searchRendering);

        updateFilterAccessibility($searchRendering.find('.search-rendering__filters-wrapper'));

        window.pageInitialized = true;
    }        
};